export default "__VITE_ASSET__CKMwBwpJ__"